// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"9496bdbb","613":"67c8d38b","727":"56cfec79","738":"d3d41ce6","741":"a40ef3fa","752":"387913f9","787":"8dcdf69d","920":"e59d1d40"}[chunkId] + ".chunk.css";
};